/* eslint-disable eqeqeq */
import React from 'react';
import { container } from 'tsyringe';
import { ProvinsiPresenter } from '../../../../../../data/presenters/ProvinsiPresenter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provinsi } from '../../../../../../entities/Provinsi';
import {
  removeCache,
  CACHE_KEYS,
} from '../../../../../../app/misc/CacheStorage';

interface IState {
  isLoading: boolean;
  jumlahPage: number;
  page: number;
  keyword: string;
  row: number;
  totalProvinsi: number;
  provinsi: Provinsi[];
  formId: number;
  formDialog: string;
  formNameProvinsi: string;
  formLoading: boolean;
  showDialog: boolean;
  showDialogDelete: boolean;
}

interface InitialState {
  state: IState;
  getProvinsi: Function;
  setPage: Function;
  setPageRow: Function;
  searchProvinsi: Function;
  setFormDialog: Function;
  setUpdate: Function;
  actionFormDialog: Function;
  setFormNameProvinsi: Function;
  setShowDialog: Function;
  setShowDialogDelete: Function;
  deleteProvinsi: Function;
}

const initialState = {
  state: {
    isLoading: true,
    jumlahPage: 0,
    page: 1,
    keyword: '',
    row: 10,
    totalProvinsi: 1,
    provinsi: [],
    formDialog: '',
    formId: 0,
    formNameProvinsi: '',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
  },
  getProvinsi: () => {},
  searchProvinsi: () => {},
  setPage: () => {},
  setPageRow: () => {},
  setFormDialog: () => {},
  setUpdate: () => {},
  actionFormDialog: () => {},
  setFormNameProvinsi: () => {},
  setShowDialog: () => {},
  deleteProvinsi: () => {},
  setShowDialogDelete: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: MasterProvinsiProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    jumlahPage: 0,
    page: 1,
    keyword: '',
    row: 10,
    totalProvinsi: 0,
    provinsi: [],
    formDialog: '',
    formId: 0,
    formNameProvinsi: '',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
  });

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      page: value,
    }));
  };

  const setPageRow = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      row: value,
    }));
  };

  const setJumlahPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPage: value,
    }));
  };

  const getProvinsi = async (pagee: number, keyword: string, row: number) => {
    setLoading(true);

    try {
      const provinsiPresenter = container.resolve(ProvinsiPresenter);
      const getAllProvinsi = await provinsiPresenter.getAllProvinsi(
        pagee,
        row,
        keyword
      );

      const data = getAllProvinsi;

      if (!data || data.length === 0) {
        setState((prevstate) => ({
          ...prevstate,
          provinsi: [],
          jumlahPage: 0,
        }));
      } else {
        setJumlahPage(data[0].jumlahData / row);
        setState((prevstate) => ({
          ...prevstate,
          provinsi: data,
        }));
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const searchDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  

  const searchProvinsi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      keyword: value,
    }));
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      getProvinsi(1, value, state.row);
    }, 500);

  };

  const setFormDialog = (value: string) => {
    clearForm();
    setState((prevstate) => ({
      ...prevstate,
      formDialog: value,
    }));
  };

  const setUpdate = (value: Provinsi) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      formNameProvinsi: value.nama_provinsi,
    }));
  };

  const setFormLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      formLoading: value,
    }));
  };

  const actionFormDialog = async () => {
    setFormLoading(true);

    if (state.formNameProvinsi == '') {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      return;
    }

    try {
      const provinsiPresenter = container.resolve(ProvinsiPresenter);
      if (state.formDialog == 'Tambah') {
        const action = await provinsiPresenter.createProvinsi(
          state.formNameProvinsi
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialog(false);
          getProvinsi(state.page, state.keyword, state.row);
          clearForm();
          removeCache(CACHE_KEYS.LIST_PROVINSI);
        } else {
          toast.error('Ada Kesalahan Saat Tambah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else if (state.formDialog == 'Ubah') {
        const action = await provinsiPresenter.updateProvinsi(
          state.formId,
          state.formNameProvinsi
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialog(false);
          getProvinsi(state.page, state.keyword, state.row);
          clearForm();
          removeCache(CACHE_KEYS.LIST_PROVINSI);
        } else {
          toast.error('Ada Kesalahan Saat Ubah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);

      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setFormNameProvinsi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formNameProvinsi: value,
    }));
  };

  const setShowDialog = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialog: value,
    }));
  };

  const clearForm = () => {
    setState((prevstate) => ({
      ...prevstate,
      formId: 0,
      formNameProvinsi: '',
    }));
  };

  const deleteProvinsi = async () => {
    setFormLoading(true);

    try {
      const provinsiPresenter = container.resolve(ProvinsiPresenter);
      const action = await provinsiPresenter.deleteProvinsi(state.formId);
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success(data.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogDelete(false);
        getProvinsi(state.page, state.keyword, state.row);
        clearForm();
        removeCache(CACHE_KEYS.LIST_PROVINSI);
      } else {
        toast.error('Ada Kesalahan Saat Hapus Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);

      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setShowDialogDelete = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDelete: value,
    }));
  };

  return (
    <MasterProvinsiProvider
      value={{
        state,
        getProvinsi,
        setPage,
        setPageRow,
        searchProvinsi,
        setFormDialog,
        setUpdate,
        actionFormDialog,
        setFormNameProvinsi,
        setShowDialog,
        deleteProvinsi,
        setShowDialogDelete,
      }}
    >
      {children}
    </MasterProvinsiProvider>
  );
};

export const useMasterProvinsiContext = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useMasterProvinsiContext,
  Provider,
};
